import { useEffect, useRef } from 'react';

const EVENTS = ['pointerdown', 'keydown', 'scroll', 'touchstart'];

/** Calls onIdle after `ms` without any touch / key / scroll while `active`. */
export const useIdle = (active, ms, onIdle) => {
  const cb = useRef(onIdle);
  cb.current = onIdle;
  useEffect(() => {
    if (!active) return undefined;
    let timer;
    const arm = () => { clearTimeout(timer); timer = setTimeout(() => cb.current(), ms); };
    arm();
    EVENTS.forEach((e) => window.addEventListener(e, arm, { passive: true }));
    return () => { clearTimeout(timer); EVENTS.forEach((e) => window.removeEventListener(e, arm)); };
  }, [active, ms]);
};

export default useIdle;
